import ChatWindow from './src/Index.vue';

export default ChatWindow;
